export default "__VITE_ASSET__DG60TSs2__"